"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lib_1 = require("@brandfree-front/lib");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const StoresUtil_1 = require("../../util/StoresUtil");
const ContactFormContent_1 = __importDefault(require("../contactform/ContactFormContent"));
const ContactFormFooter_1 = __importDefault(require("../contactform/ContactFormFooter"));
const ContactFormHeader_1 = __importDefault(require("../contactform/ContactFormHeader"));
let PublicPrivacyNoticeContactModal = class PublicPrivacyNoticeContactModal extends react_1.default.Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "publicPrivacyNoticeStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    render() {
        var _a, _b, _c;
        return (react_1.default.createElement(lib_1.Modal, { size: "8-col", isHeaderSticky: true, "aria-labelledby": "modal-heading", hasContentComponent: true, onClose: () => this.publicPrivacyNoticeStore.closeContactInformationModal() },
            react_1.default.createElement(lib_1.ModalHeader, null,
                react_1.default.createElement(ContactFormHeader_1.default, { heading: (_a = this.publicPrivacyNoticeStore.contactModal) === null || _a === void 0 ? void 0 : _a.heading })),
            react_1.default.createElement("form", null,
                react_1.default.createElement(lib_1.ModalContent, null,
                    react_1.default.createElement(ContactFormContent_1.default, { contactFormType: (_b = this.publicPrivacyNoticeStore.contactModal) === null || _b === void 0 ? void 0 : _b.type, textAreaComment: (_c = this.publicPrivacyNoticeStore.contactModal) === null || _c === void 0 ? void 0 : _c.textAreaComment })),
                react_1.default.createElement(lib_1.ModalFooter, null,
                    react_1.default.createElement(ContactFormFooter_1.default, { isInsideModal: true })))));
    }
};
PublicPrivacyNoticeContactModal = __decorate([
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], PublicPrivacyNoticeContactModal);
exports.default = PublicPrivacyNoticeContactModal;
